import {
  GET_REALISM,
  START,
  TICK,
  FAIL,
  SUCCESS
} from "../constants/action-types";

export default (realism = {}, action) => {
  const {type, response, error} = action;
  switch (type) {
    case GET_REALISM + START:
      return {progress: 0, loading: true, loaded: false};
    case GET_REALISM + TICK:
      return {...response, loading: true, loaded: false};
    case GET_REALISM + SUCCESS:
      return {
        ...response,
        loading: false,
        loaded: true
      };
    case GET_REALISM + FAIL:
      return {...realism, error, loading: false, loaded: true};
  }
  return realism;
};
